/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import IconBar from './IconBar';
import CommentDisplay from './CommentDisplay';
import CommentInput from './CommentInput';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: [],
      commentIndex: 0,
    };
    this.handleComment = this.handleComment.bind(this);
  }
  handleComment(comment, username, commentIndex) {
    const comments = this.state.comments.slice();
    this.setState({
      comments: comments.concat({
        comment: comment,
        isLiked: false,
        username: username,
        index: commentIndex,
      }),
      commentIndex: commentIndex + 1,
    });
  }
  handleCommentLike(index) {
    const comments = this.state.comments.slice();
    const newValue = !comments[index].isLiked;
    comments[index].isLiked = newValue;
    this.setState({
      comments: comments,
    });
  }
  render() {
    const { author } = this.props;
    const { text } = this.props;
    const { username } = this.props;
    const { hoursOld } = this.props;
    const { isLiked } = this.props;
    const { onLike } = this.props;
    const { comments } = this.state;
    const { commentIndex } = this.state;
    return (
      <footer>
        <div className="footer-top-container">
          <IconBar username={username} isLiked={isLiked} onLike={onLike} />
          <div className="post-message">
            <p>
              <a href="#">{author}</a> {text}
            </p>
          </div>
          <CommentDisplay
            hoursOld={hoursOld}
            comments={comments}
            username={username}
            onCommentLike={(index) => this.handleCommentLike(index)}
          />
        </div>
        <CommentInput
          username={username}
          commentIndex={commentIndex}
          handleComment={this.handleComment}
        />
      </footer>
    );
  }
}

export default Footer;
